import { mapActions, mapState } from "vuex";
import SummaryLine from "../chart-types/summary-line";
import { AlertTypes } from "../../../constants/alert_types";
import i18n from "../../../plugins/i18n";

export default {
  name: "LactationChart",
  props: {},
  components: { SummaryLine },
  data: () => ({
    categories: [AlertTypes.Heat, AlertTypes.RepeatHeat, AlertTypes.Calving]
  }),
  computed: {
    ...mapState({
      chartData(state) {
        const filtered = this.categories
          .reduce((obj, key) => ({ ...obj, [key]: state.alerts.totals[key] }), {});
        const lactationData = filtered;
        const sumOfData = Object.keys(lactationData)
          .map(k => lactationData[k])
          .reduce((a, b) => a + b, 0);
        return Object.keys(lactationData).map(key => {
          return {
            data: lactationData[key],
            key: key.replace(" ", "-").toLocaleLowerCase(),
            name: i18n.t(`cowGenerics.cowLogs.${key}`),
            percentage: (lactationData[key] / sumOfData) * 100
          };
        });
      },
      isFetching: state => state.chart.isFetching
    })
  },
  methods: {
    ...mapActions("states", {
      getStates: "getStates",
      clearStates: "clear",
    }),

  },
};



// WEBPACK FOOTER //
// ./src/components/_charts/actions/actions-chart.js